import { createRoot } from 'react-dom/client';
import { LogIn } from './log-in.component';

createRoot(document.getElementById('root')).render(<LogIn/>);
